export default {
  header: 'Precisamos de verificar o seu número de telemóvel',
  buttons: {
    confirm: 'Confirmar',
  },
  toasts: {
    invalid_code: 'Código inválido. Tente novamente.',
  },
};
